exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body {\n  padding: 0;\n  margin: 0; }\n\n.dhis-gis-menu {\n  button: disabled;\n    button-opacity: 0.5; }\n\n#context-menu {\n  position: fixed;\n  top: 100px;\n  left: 100px; }\n\n#loading-mask {\n  position: relative;\n  height: 100%;\n  z-index: 2000; }\n  #loading-mask:before {\n    content: '';\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    background-color: rgba(0, 0, 0, 0.25); }\n  #loading-mask:after {\n    content: \"\";\n    position: absolute;\n    border-width: 3px;\n    border-style: solid;\n    border-color: transparent white white;\n    border-radius: 50%;\n    width: 24px;\n    height: 24px;\n    top: calc(50% - 12px);\n    left: calc(50% - 12px);\n    animation: 2s linear 0s normal none infinite running spin;\n    filter: drop-shadow(0 0 2 rgba(0, 0, 0, 0.33)); }\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg); }\n  to {\n    transform: rotate(359deg); } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./scss/app.scss
// module id = 1237
// module chunks = 0